// import React, { useEffect, useRef, useState } from 'react'
// import { useSearchParams, useNavigate } from 'react-router-dom'
// import { useElements, useStripe } from '@stripe/react-stripe-js'
// import classNames from 'classnames'

// const FcPublicPayment: React.FC = () => {
//   const [searchParams] = useSearchParams()
//   const clientSecret = searchParams.get('clientSecret')
//   const amount = searchParams.get('amount')
//   const element = useElements()
//   const stripe = useStripe()
//   const navigate = useNavigate()
//   const cardNumberRef = useRef<HTMLInputElement>(null)
//   const cardExpiryRef = useRef<HTMLInputElement>(null)
//   const cardCvcRef = useRef<HTMLInputElement>(null)

//   const [cardNumberElement, setCardNumberElement] = useState<any>(null)
//   const [cardExpiryElement, setCardExpiryElement] = useState<any>(null)
//   const [cardCvcElement, setCardCvcElement] = useState<any>(null)

//   const [isButtonClicked, setIsButtonClicked] = useState(false)

//   useEffect(() => {
//     if (!stripe || !element) {
//       return
//     }

//     const cardNumberElement = element.create('cardNumber')
//     const cardExpiryElement = element.create('cardExpiry')
//     const cardCvcElement = element.create('cardCvc')

//     if (cardNumberRef.current) {
//       cardNumberElement.mount(cardNumberRef.current)
//     }

//     if (cardExpiryRef.current) {
//       cardExpiryElement.mount(cardExpiryRef.current)
//     }

//     if (cardCvcRef.current) {
//       cardCvcElement.mount(cardCvcRef.current)
//     }

//     setCardNumberElement(cardNumberElement)
//     setCardExpiryElement(cardExpiryElement)
//     setCardCvcElement(cardCvcElement)

//     cardNumberElement.update({ placeholder: 'Numéro de carte' })
//     cardExpiryElement.update({ placeholder: 'Date' })
//     cardCvcElement.update({ placeholder: 'CVC' })

//     return () => {
//       cardNumberElement.destroy()
//       cardExpiryElement.destroy()
//       cardCvcElement.destroy()
//     }
//   }, [stripe, element])

//   const handleSubmit = async (e: any) => {
//     setIsButtonClicked(true)
//     e.preventDefault()
//     if (!stripe || !element || !cardNumberElement) {
//       return
//     }
//     const clientSecretKey = clientSecret || ''

//     const { paymentIntent } = await stripe.confirmCardPayment(clientSecretKey, {
//       payment_method: {
//         card: cardNumberElement,
//       },
//     })
//     // functionTracks('3')
//     if (paymentIntent?.status === 'succeeded') {
//       navigate('/success')
//       setIsButtonClicked(true)
//     } else {
//       navigate('/error')
//     }
//   }

//   return (
//     <div className="w-full px-8 ">
//       <form onSubmit={handleSubmit} id="payment-form" autoComplete="off">
//         <div className="relative mt-3 flex justify-center ">
//           <div
//             id="card-number"
//             ref={cardNumberRef}
//             className="p-2 border w-full  h-[35px] rounded-md bg-[#F9FAFB] placeholder:text-[#9CA3AF]"
//           ></div>
//         </div>

//         <div className="relative flex justify-center mt-4">
//           <div
//             id="card-expiry"
//             ref={cardExpiryRef}
//             className="p-2 border w-full  h-[35px] rounded-md bg-[#F9FAFB] placeholder:text-[#9CA3AF]"
//           ></div>
//         </div>

//         <div className="relative flex justify-center mt-4">
//           <div
//             id="card-cvc"
//             ref={cardCvcRef}
//             className="p-2 border w-full  h-[35px] rounded-md bg-[#F9FAFB] placeholder:text-[#9CA3AF]"
//           ></div>
//         </div>

//         <div className="flex justify-center  items-center mt-8 ">
//           <button
//             className={classNames(
//               `text-[18px] text-[#FFF] w-full  h-[35px] rounded-md
//                   ${isButtonClicked ? 'bg-[#d3d3d3] ' : 'bg-[#4743C9]'}
//                   `,
//             )}
//             disabled={isButtonClicked}
//           >
//             Payer <span className="pl-4 font-semibold text-sm">{amount} €</span>
//           </button>
//         </div>
//       </form>
//     </div>
//   )
// }

// export default FcPublicPayment

import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useElements, useStripe } from '@stripe/react-stripe-js'
import classNames from 'classnames'
import IconCarte from '../../assets/iconCarteBancaire.svg'
import IconCalendrier from '../../assets/iconCalendrier.svg'
import Visa from '../../assets/visaCarte.svg'
import Mastercarte from '../../assets/Mastercarte.svg'

const FcPublicPayment: React.FC = () => {
  const [searchParams] = useSearchParams()
  const clientSecret = searchParams.get('clientSecret')
  const amount = searchParams.get('amount')
  const elements = useElements() 
  const stripe = useStripe()
  const navigate = useNavigate()
  const cardNumberRef = useRef<HTMLInputElement>(null)
  const cardExpiryRef = useRef<HTMLInputElement>(null)
  const cardCvcRef = useRef<HTMLInputElement>(null)
  const [cardNumberElement, setCardNumberElement] = useState<any>(null)
  const [cardExpiryElement, setCardExpiryElement] = useState<any>(null)
  const [cardCvcElement, setCardCvcElement] = useState<any>(null)
  // const [isButtonClicked, setIsButtonClicked] = useState(false)


  const [cardComplete, setCardComplete] = useState({
    number: false,
    expiry: false,
    cvc: false,
  })
  const style ={
    base:{
      color:'#5754E5',
    '::placeholder': {
      color:'#D1D1FF'
    }}
    
  }
  

    useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]')
    const previousContent = meta?.getAttribute('content')
    meta?.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    )
    return () => {
      if (previousContent) {
        meta?.setAttribute('content', previousContent)
      }
    }
  }, [])

  useEffect(() => {
    if (!stripe || !elements) {
      return
    }
    const cardNumberElement = elements.create('cardNumber', {style, placeholder:'Numéro de carte'})
    const cardExpiryElement = elements.create('cardExpiry', {style, placeholder: 'Date d’expiration - mm/aa',})
    const cardCvcElement = elements.create('cardCvc', {style, placeholder:'CVC'})
    if (cardNumberRef.current) {
      cardNumberElement.mount(cardNumberRef.current)
    }
    if (cardExpiryRef.current) {
      cardExpiryElement.mount(cardExpiryRef.current)
    }
    if (cardCvcRef.current) {
      cardCvcElement.mount(cardCvcRef.current)
    }

    cardNumberElement.on('change', (event: any) => {
      setCardComplete((prev) => ({ ...prev, number: event.complete }))
    })

    cardExpiryElement.on('change', (event: any) => {
      setCardComplete((prev) => ({ ...prev, expiry: event.complete }))
    })
    cardCvcElement.on('change', (event: any) => {
      setCardComplete((prev) => ({ ...prev, cvc: event.complete }))
    })

    setCardNumberElement(cardNumberElement)
    setCardExpiryElement(cardExpiryElement)
    setCardCvcElement(cardCvcElement)
    
    return () => {
      cardNumberElement.destroy()
      cardExpiryElement.destroy()
      cardCvcElement.destroy()
    }
  }, [stripe, elements])

  const handleSubmit = async (e: any) => {
    // setIsButtonClicked(true)
    e.preventDefault()
   
    if (!stripe || !elements || !cardNumberElement) {
      return
    }
    const clientSecretKey = clientSecret || ''
    const { paymentIntent } = await stripe.confirmCardPayment(clientSecretKey, {
      payment_method: { card: cardNumberElement },
    })
    // functionTracks('3')
    if (paymentIntent?.status === 'succeeded') {
      // setIsButtonClicked(true)
      navigate('/appMobile/success')
    } else {
      navigate('/error')
    }
  }
  return (

    <div className="w-full px-8">

      <form className='flex flex-col gap-3' onSubmit={handleSubmit} id="payment-form" autoComplete="off">
        {/* <h1 className='h2'>Payez avec votre carte en toute sécurité</h1> */}
         
          <div className=" w-full relative  pl-4 flex  gap-4 items-center justify-center overflow-hidden h-[48px] rounded-[16px] border border-[#AEB6FB]">
           <img src={IconCarte} width={24} height={24} alt=''/>
            <div
            id="card-number"
            ref={cardNumberRef}
            className="w-full"
          ></div>
        </div>

         <div className=" w-full relative  pl-4 flex  gap-4 items-center justify-center overflow-hidden h-[48px] rounded-[16px] border border-[#AEB6FB]">
           <img src={IconCalendrier} width={24} height={24} alt=''/>
            <div
            id="card-expiry"
            ref={cardExpiryRef}
            className="w-full"
          ></div>{' '}
        </div>
         <div className=" w-full relative  pl-4 flex  gap-4 items-center justify-center overflow-hidden h-[48px] rounded-[16px] border border-[#AEB6FB]">
          <div
            id="card-cvc"
            ref={cardCvcRef}
            className="w-full"
          ></div>{' '}
        </div>
        {/* <div className="flex justify-center items-center "> */}
          <button
            className={classNames(
              `text-[18px] font-semibold text-[#FFF] w-full h-[48px] rounded-[16px]
                ${!(cardComplete.cvc && cardComplete.expiry && cardComplete.number) ? 'bg-[#D1D1FF] ' : 'bg-[#5754E5]'}
              `,
            )}
            //   `text-[18px] text-[#FFF] w-full h-[35px] rounded-md ${!(cardComplete.cvc && cardComplete.number && cardComplete.expiry ) ? 'bg-[#d3d3d3] ' : 'bg-[#4743C9]'} , `,
            // )}
            disabled={!(cardComplete.cvc && cardComplete.number && cardComplete.expiry )}
          >
            Payer
            <span className="pl-4 font-semibold text-sm">{amount} €</span>
          </button>{' '}
        {/* </div>{' '} */}

              <div className='text-[#6B7280] text-center text-[12px]'>
                  <p>
                    Selon votre établissement bancaire, vous pourrez être
                    redirigé vers la page d&apos;authentification de votre banque
                    avant la validation de votre paiement.
                  </p>
                  <div className='mt-[10px]'>
                    Sécurisé par :
                  </div>
                  <div className='flex items-center justify-center gap-10'>
                  <img src={Visa} alt=''/>
                  <img src={Mastercarte} alt=''/>
                  </div>
                </div>
      </form>{' '}
    </div>
  )
}
export default FcPublicPayment
